import { css } from "lit";
// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.color-theme {
  position: relative;
}

.color-theme__button {
  display: flex;

  column-gap: 0.25rem;
  align-items: center;

  padding: 0 0.5rem;
  margin: 0;

  font: inherit;

  color: inherit;

  background-color: transparent;
  border: none;
}

.color-theme__button:is(:hover,:focus),.color-theme__button[aria-expanded="true"] {
    background-color: var(--color-background-secondary);
  }

.color-theme__dropdown {
  position: absolute;
  z-index: 1;

  width: max-content;

  padding: 0.75rem;
  margin: 0;

  background-color: var(--color-background-primary);
  border: 1px solid var(--color-text-secondary);
}

.color-theme__dropdown[data-side="left"] {
    right: 0;
  }

.color-theme__dropdown[data-side="right"] {
    left: 0;
  }

.color-theme__list {
  width: max-content;

  padding: 0;
  margin: 0;

  list-style: none;

  background-color: var(--color-background-primary);
}

.color-theme__option {
  display: flex;

  column-gap: 0.25rem;
  align-items: center;

  width: 100%;

  padding: 0.25rem;
  margin: 0;

  font: inherit;

  color: var(--color-text-secondary);

  background-color: transparent;
  border: none;
}

.color-theme__option:hover {
    background-color: var(--color-background-secondary);
  }
`, "",{"version":3,"sources":["webpack://./components/color-theme/index.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;;EAEb,mBAAmB;EACnB,mBAAmB;;EAEnB,iBAAiB;EACjB,SAAS;;EAET,aAAa;;EAEb,cAAc;;EAEd,6BAA6B;EAC7B,YAAY;AAMd;;AAJE;IAEE,mDAAmD;EACrD;;AAGF;EACE,kBAAkB;EAClB,UAAU;;EAEV,kBAAkB;;EAElB,gBAAgB;EAChB,SAAS;;EAET,iDAAiD;EACjD,6CAA6C;AAS/C;;AAPE;IACE,QAAQ;EACV;;AAEA;IACE,OAAO;EACT;;AAGF;EACE,kBAAkB;;EAElB,UAAU;EACV,SAAS;;EAET,gBAAgB;;EAEhB,iDAAiD;AACnD;;AAEA;EACE,aAAa;;EAEb,mBAAmB;EACnB,mBAAmB;;EAEnB,WAAW;;EAEX,gBAAgB;EAChB,SAAS;;EAET,aAAa;;EAEb,kCAAkC;;EAElC,6BAA6B;EAC7B,YAAY;AAKd;;AAHE;IACE,mDAAmD;EACrD","sourcesContent":[".color-theme {\n  position: relative;\n}\n\n.color-theme__button {\n  display: flex;\n\n  column-gap: 0.25rem;\n  align-items: center;\n\n  padding: 0 0.5rem;\n  margin: 0;\n\n  font: inherit;\n\n  color: inherit;\n\n  background-color: transparent;\n  border: none;\n\n  &:is(:hover, :focus),\n  &[aria-expanded=\"true\"] {\n    background-color: var(--color-background-secondary);\n  }\n}\n\n.color-theme__dropdown {\n  position: absolute;\n  z-index: 1;\n\n  width: max-content;\n\n  padding: 0.75rem;\n  margin: 0;\n\n  background-color: var(--color-background-primary);\n  border: 1px solid var(--color-text-secondary);\n\n  &[data-side=\"left\"] {\n    right: 0;\n  }\n\n  &[data-side=\"right\"] {\n    left: 0;\n  }\n}\n\n.color-theme__list {\n  width: max-content;\n\n  padding: 0;\n  margin: 0;\n\n  list-style: none;\n\n  background-color: var(--color-background-primary);\n}\n\n.color-theme__option {\n  display: flex;\n\n  column-gap: 0.25rem;\n  align-items: center;\n\n  width: 100%;\n\n  padding: 0.25rem;\n  margin: 0;\n\n  font: inherit;\n\n  color: var(--color-text-secondary);\n\n  background-color: transparent;\n  border: none;\n\n  &:hover {\n    background-color: var(--color-background-secondary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default css([___CSS_LOADER_EXPORT___.toString()]);
